<template>
    <v-container class="mt-10">
      <v-col
        md="12"
        class="text-h3 text-center mb-4"
        :style="{ color: '#0c4f88' }"
      >
        Produk Kafalah
      </v-col>
      <v-row>
        <v-col md="3">
          <template>
            <div>
              <p class="text--primary text-h5">Produk Kafalah Kami</p>
              <p>
                Produk Penjaminan dari Unit Usaha Syariah PT Orion Penjaminan Indonesia
                <!-- <b>Loan</b> & <b>Non Loan</b> -->
              </p>
            </div>
          </template>
          <div class="d-flex align-end justify-center" :style="{ height: '25%' }">
            <v-btn rounded outlined color="grey" dark @click="prevSlide">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <v-btn
              rounded
              outlined
              class="ml-2"
              color="grey"
              dark
              @click="nextSlide"
            >
              <v-icon>mdi-arrow-right</v-icon>
            </v-btn>
          </div>
        </v-col>
        <v-col md="9">
          <VueSlickCarousel v-bind="settings" ref="carousel">
            <div v-for="(item, index) in carouselData" :key="index">
              <div>
                <v-card
                  class="mx-2 mb-3 custom-card"
                  @click="
                    ProductDetail(
                      item.web_product_src_url,
                      item.web_product_name,
                      item.web_product_detail
                    )
                  "
                >
                  <v-img
                    class="white--text align-end"
                    height="300px"
                    :src="
                      require('@/assets/products/' + item.web_product_src_url)
                    "
                  >
                  </v-img>
                  <v-card-subtitle class="pl-0">
                    <!-- <v-chip class="ma-2" small>{{
                      item.web_product_cashloan
                    }}</v-chip> -->
                  </v-card-subtitle>
                  <v-card-text
                    class="pl-0 mb-5 text--primary"
                    :style="{ 'min-height': '80px' }"
                  >
                    <div>{{ item.web_product_name }}</div>
                  </v-card-text>
                </v-card>
              </div>
            </div>
          </VueSlickCarousel>
        </v-col>
      </v-row>
      <v-dialog
        v-model="dialog.detail"
        width="900px"
        persistent
        style="border-radius: 20px"
      >
        <v-card>
          <v-card-actions style="height: 80px">
            <v-spacer></v-spacer>
            <v-btn
              rounded
              outlined
              color="grey"
              dark
              @click="dialog.detail = false"
              class="mr-5"
            >
              X
            </v-btn>
          </v-card-actions>
          <v-divider></v-divider>
          <v-progress-linear
            indeterminate
            v-if="loading.detail"
          ></v-progress-linear>
          <v-container>
            <v-row class="mx-2">
              <v-col
                cols="12"
                class="text-h4 text-center"
                style="align-self: center; color: #114e87"
              >
                {{ detail.name }}
              </v-col>
              <v-col cols="12" class="d-flex justify-center mb-4">
                <v-row>
                  <!-- <v-col cols="12" sm="4" md="3" class="text-center">
                    <img
                      :src="
                        detail.img
                          ? require(`@/assets/products/${detail.img}`)
                          : require('@/assets/user-no-photo.png')
                      "
                      :alt="detail.img ? detail.img : 'Placeholder Image'"
                      :style="{ border: '1px solid #ccc' }"
                      height="250"
                      width="250"
                    /> -->
                  <!-- </v-col> -->
                  <v-col cols="12" class="d-flex align-center">
                    <div class="text-justify" v-html="detail.description"></div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </template>
  
  <script>
  import VueSlickCarousel from "vue-slick-carousel";
  import "vue-slick-carousel/dist/vue-slick-carousel.css";
  
  export default {
    name: "MyComponent",
    components: { VueSlickCarousel },
    data() {
      return {
        dialog: {
          detail: false,
        },
        loading: {
          detail: false,
        },
        detail: {
          name: "",
          img: "",
          description: "",
        },
        settings: {
          arrows: false, // Sembunyikan panah bawaan karena kita akan menambahkan tombol manual
          dots: false,
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 1,
          initialSlide: 0,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        },
        carouselData: [], // Inisialisasi carouselData sebagai array kosong
      };
    },
    created() {
      // Setelah komponen dibuat, inisialisasi carouselData dengan data yang diperlukan
      this.carouselData = [
        {
          web_product_id: 1,
          web_product_name: "Kafalah Pembiayaan Multiguna",
          web_product_src_url: "kafalah-pembiayaan-multiguna.jpg",
          web_product_cashloan: "Loan",
          web_product_detail:
            "Penjaminan atas Pembiayaan yang diberikan oleh Penerima Jaminan/Makful Lahu kepada Terjamin/Makful `Anhu untuk memenuhi berbagai kebutuhan dengan sumber pengembalian adalah penghasilan tetap/gaji perbulan yang sah dari tempat Terjamin/Makful `Anhu bekerja.",
        },
        {
          web_product_id: 2,
          web_product_name: "Kafalah Pembiayaan Mikro",
          web_product_src_url: "kafalah-pembiayaan-mikro.jpg",
          web_product_cashloan: "Loan",
          web_product_detail:
            "Penjaminan atas Pembiayaan Modal Kerja dan/atau investasi yang diajukan untuk mendukung kelancaran kegiatan usaha yang dilakukan oleh Pelaku Usaha Mikro, Kecil dan Menengah / UMKM.",
        },
      ];
    },
    methods: {
      prevSlide() {
        this.$refs.carousel.prev();
      },
      nextSlide() {
        this.$refs.carousel.next();
      },
      ProductDetail(image, name, desc) {
        this.dialog.detail = true;
        this.detail.img = image;
        this.detail.name = name;
        this.detail.description = desc;
      },
    },
  };
  </script>
  
  <style scoped>
  .custom-card {
    padding: 0px 22px; /* Sesuaikan padding sesuai kebutuhan Anda */
  }
  </style>
  